import { zip } from 'lodash';

export const openingTimesDays = ['Mon - Fri:', 'Saturday:', 'Sunday:', 'Bank Holidays:'];
export const openingTimesHours = ['9.00am - 8.00pm', '9.00am - 7.30pm', '9.00am - 7.30pm', '10.00am - 5.00pm'];
export const displayTimes = zip(openingTimesDays, openingTimesHours)
  .map((dayTimes) => dayTimes.join(' '))
  .join(', ');
